Greenmile.Map = Greenmile.Map || {};
Greenmile.Map.Utility = Greenmile.Map.Utility || {};

Greenmile.Map.Utility = {
    getBingLayers: (configs) => {
      if(!configs) return;

      let result = {};
      const bingMapsKey =  configs.clientKey;
      configs.options.forEach((item) => {
        const id = 'bing'+item;
        result[id] = {
          layer: () => {
            const layer = L.tileLayer.bing({bingMapsKey: bingMapsKey, imagerySet: item});
            layer._type = 'BING';
            return layer;
          },
          label: Monet.I18n.getResourcesByKey(`RouteDetail.ToolBar.MapSources.${id}`),
          id: id
        }
      });

      return result;
    },
    getGoogleLayers: (configs) => {
      if(!configs) return;

      if(!configs.options || !configs.options.length) {
        configs.options = ["satellite", "hybrid", "roadmap", "traffic"];
        console.warn('Google maps layer types not found. Using default configs [' + configs.options.join(',') +'] .');
      }

      let result = {};
      configs.options.forEach((type) => {

        let layer = null;
        let typeToResource = type;

        if(type === 'traffic') {
            layer =  () => {
                const googleTraffic = new L.TileLayer('http://mt1.googleapis.com/vt?lyrs=m@226070730,traffic&src=apiv3&hl=en-US&' +
                    'x={x}&y={y}&z={z}&apistyle=s.t:49|s.e:g|p.h:#ff0022|p.s:60|p.l:-20,s.t:50|p.h:#2200ff|p.l:-40|' +
                    'p.v:simplified|p.s:30,s.t:51|p.h:#f6ff00|p.s:50|p.g:0.7|p.v:simplified,s.t:6|s.e:g|p.s:40|p.l:40,s.t:49' +
                    '|s.e:l|p.v:on|p.s:98,s.t:19|s.e:l|p.h:#0022ff|p.s:50|p.l:-10|p.g:0.9,s.t:65|s.e:g|p.h:#ff0000|p.v:on' +
                    '|p.l:-70&style=59,37|smartmaps',
                    { minZoom: 2, maxZoom: 18 });
                googleTraffic._type = type.toUpperCase();
                return googleTraffic;
            };
        } else {

          if (type === 'roadmap') {
              typeToResource = 'Street'
          }

          const styles = [
            { elementType: "labels", stylers: [ { visibility: "on" } ] },
            { featureType: "poi", stylers: [ { visibility: "on" } ] },
            { featureType: "administrative", stylers: [ { visibility: "on" } ] },
            { featureType: "administrative.locality", stylers: [ { visibility: "on" } ] }
          ];

          layer = () => {
            const googleLayer = new L.gridLayer.googleMutant({
              type,
              styles
            });
            googleLayer._type = type.toUpperCase();
            return googleLayer;
          }
        }

        const id = `google${typeToResource}`;
        result[id] = {
          layer: layer,
          label: Monet.I18n.getResourcesByKey(`RouteDetail.ToolBar.MapSources.${id}`),
          id: id
        }
      });

      return result;
    },

    getGreenmileLayers: () => {
      const greenmileLayers = Greenmile.Map.Utility.getGreenMileMapSources();
      if (greenmileLayers['greenmileMap']) {
        const layer = () => {
            return Greenmile.Map.Utility.createBaseLayer();
        };
        return { greenmileMap: { label: "GreenMile", id: "greenmile", layer } }
      }

      return Object.keys(greenmileLayers).reduce((acc, current) => {
        const { resource } = greenmileLayers[current];
        const layer = () => Greenmile.Map.Utility.createBaseLayerFromZenoMaps(current);
        acc[current] = {
          label: Monet.I18n.getResourcesByKey(resource),
          id: `greenmile-${current}`,
          layer,
        };
        return acc;
      }, {});
    },
    getDefaultMap: () => {
      const mapConfig = Monet.Session.Configurations.MapConfiguration.first();
      return (mapConfig.get("tmsUrl")) ? "greenmileMap" : mapConfig.get('default');
    },
    getMapSources: () => {
      const configs = Greenmile.Map.Utility.getMapProviderConfigs();
      return {
        ...Greenmile.Map.Utility.getGreenmileLayers(),
        ...Greenmile.Map.Utility.getGoogleLayers((configs.google ? configs.google.configs : null)),
        ...Greenmile.Map.Utility.getBingLayers((configs.bing ? configs.bing.configs : null)),
      };
    },

    getMapProviderConfigs: function() {
        return Monet.Session.Configurations.MapConfiguration.first().get("mapProviders");
    },

    getGreenMileMapSources: function () {
      const mapConfig = Monet.Session.Configurations.MapConfiguration.first();
      if (mapConfig.get("tmsUrl")) {
        return { greenmileMap: true };
      }
      return mapConfig.get('map-configs');
    },

    openNewTabStreetView: function (lat, lng) {
        window.open(`https://www.google.com/maps?layer=c&cbll=${lat},${lng}&cbp=12,90,0,2,5`);
    },

    getMapLocalStorageConfiguration: function () {
      const { mapmain, supplierMap } = Monet.Session.sessionStorage;
      const initialMapInfo = mapmain ? JSON.parse(mapmain): '';
      const supplierMapObj = supplierMap ? JSON.parse(supplierMap) : '';
      let lat = 0,
          lng = 0,
          zoom = 2;


      if (initialMapInfo.center) {
        lat = initialMapInfo.center.lat || 0;
        lng = initialMapInfo.center.lng || 0;
      }

      if (initialMapInfo.zoom) {
        zoom = initialMapInfo.zoom || 2;
      }

      return {
        zoom,
        latitude: lat,
        longitude: lng,
        supplierMap: (
          supplierMapObj && this.getMapSources()[supplierMapObj.supplier_map]
        ) ? supplierMapObj.supplier_map : this.getDefaultMap()
      };
    },

    createDefaultMap: function (mapSelector, options) {

        var mapConfs = Greenmile.Map.Utility.getMapLocalStorageConfiguration();
        var center = [-3.7925557, -38.497655],
            defaultOptions = {
                center: center,
                minZoom: 2,
                fadeAnimation: false,
                zoomAnimation: true,
                markerZoomAnimation: false,
                maxZoom: 18,
                zoom: mapConfs.zoom,
                crs: L.CRS.EPSG3857,
                zoomControl: false,
                measureControl: false,
                preferCanvas: true
            };

        if (mapConfs.latitude && mapConfs.longitude) {
            defaultOptions.center = [mapConfs.latitude, mapConfs.longitude];
        }

        for (var i in options) {
            defaultOptions[i] = options[i];
        }

        var map = new L.Map(mapSelector, defaultOptions);

        map.on("mouseover", function () {
            this._container.focus();
        }.bind(map));

        return map;
    },

    createBaseLayerFromZenoMaps: function (provider) {
      const mapConfig = Monet.Session.Configurations.MapConfiguration.first();
      const zenoMap = mapConfig.get('map-configs')[provider];
      const zenoMapProvider = zenoMap.mapProvider;
      const zenoMapAreas = "*";
      const zenoMapAuthToken = `${zenoMapProvider},${zenoMapAreas}`;
      const baseLayer = L.maplibreGL({
        style: zenoMap.mapUrl,
        transformRequest: (url, resourceType) => {
          return { url: url, headers: { Authorization: zenoMapAuthToken } };
        },
      });
      baseLayer._type = provider
      return baseLayer;
    },

    createBaseLayer: function () {
      const mapConfig = Monet.Session.Configurations.MapConfiguration.first();
      if (mapConfig.get("tmsUrl")) {
        const mapServerUrl = mapConfig.get("tmsUrl") + '/' + mapConfig.get("tilesets")[0]+'/{z}/{x}/{y}.png';
        const baseLayer = L.tileLayer(mapServerUrl, {
          transparent: true,
          reuseTiles: true,
          unloadInvisibleTiles: true,
          crs: L.CRS.EPSG3857,
          zoomControl: false,
          attribution: '<a href="http://osm.org/copyright">OpenStreetMap</a>'
        });
        baseLayer._type = "GREENMILE";
        return baseLayer;
      }
      return this.createBaseLayerFromZenoMaps(mapConfig.get('default'));
    },

    //https://github.com/Leaflet/Leaflet.heat
    createHeatmapLayer: function (kind, id, data, options) {
        const defaultOptions = {
            max: 0.4,
            blur: 35,
            radius: 15, //pixels
        }
        const layer = L.heatLayer(data, options ? options : defaultOptions);
        layer.kind = kind;
        layer.id = id;
        return layer;
    },

    setMarkerFocus: function (sourceSessionData, position) {

        var map = sourceSessionData.map;
        var latlng = [position.lat, position.lng];

        if (!sourceSessionData.timeoutLayerFocus) {
            sourceSessionData.timeoutLayerFocus = [];
        }

        var clearAllTimeout = function () {

            var timeOuts = sourceSessionData.timeoutLayerFocus;

            for (var key in timeOuts) {
                clearTimeout(timeOuts[key]);
                timeOuts.splice(key, 1);
            }

            sourceSessionData.timeoutLayerFocus = timeOuts;

        };

        //cria a função pra sumir o destaque da imagem
        var dismissFocus = function () {

            map.removeLayer(sourceSessionData.layerFocus);
            clearAllTimeout();

        };

        if (sourceSessionData.layerFocus) {
            dismissFocus();
        }

        var markerFocusIcon = null;
        markerFocusIcon = L.divIcon({
            className: "markerDetailRoute",
            html: '<div class="greenmileMarkerFocusIcon"></div>',
            iconSize: [50, 50]
        });

        var markerFocus = new L.marker(latlng, {
            icon: markerFocusIcon,
            zIndexOffset: -1
        });

        markerFocus.addTo(map);
        sourceSessionData.layerFocus = markerFocus;

        if (sourceSessionData.timeoutLayerFocus.length > 0) {
            clearAllTimeout();
        }

        var timeout = setTimeout(function () {
            dismissFocus();
        }, 4000);

        sourceSessionData.timeoutLayerFocus.push(timeout);
        map.setView(latlng, map.getMaxZoom());

    },
    removeLayerByKind: function (map, kinds) {

        var layers = map._layers;
        for (var key in layers) {
            var layer = layers[key];

            if (layer.kind && kinds.indexOf(layer.kind) !== -1) {
                map.removeLayer(layer);
            }
        }

    },

    removeLayerByKindAndIdRestriction: function (map, kinds, id) {

        var layers = map._layers;
        for (var key in layers) {
            var layer = layers[key];

            if (layer.kind && kinds.indexOf(layer.kind) !== -1 && layer.id != id) {
                map.removeLayer(layer);
            }
        }

    },

    getLayerByKindAndId: function (map, kind, id) {

        var layers = map._layers;
        for (var key in layers) {
            var layer = layers[key];
            if (layer.kind == kind && layer.id == id) {
                return layer;
            }

        }
    },

    drawAccuracyArea: (latitude, longitude, accuracy, color, map, kind) => {
        const circle = L.circle([latitude, longitude], {
            radius: accuracy,
            color,
            fillColor: color,
            fillOpacity: 0.3,
            weight: 2,
        });
        circle.kind = kind;
        circle.addTo(map);
    },

    drawLine: (latLongInit, latLongEnd, color, map, kind) => {
        const polyline = L.polyline([latLongInit, latLongEnd], {
            color,
            weight: 2
        });
        polyline.kind = kind;
        polyline.addTo(map);
    },

    adjustZoom: (e, zoomSliderSelector) => {
        let layerType = e.layer && ((e.layer.options && e.layer.options.type) || e.layer._type);
        const map = e.target;
        const mapZoomRange = $(zoomSliderSelector + " .mapZoomRange");

        if (layerType) {
          layerType = layerType.toLowerCase();
          const maxZoom18 = ['traffic', 'green'];
          const maxZoom22 = ['roadmap'];

          const hasSatelliteOrHybridLayer = Object.values(map._layers).some(layer => {
            return layer.options.type === 'satellite' || layer.options.type === 'hybrid';
          });

          if (hasSatelliteOrHybridLayer) {
              mapZoomRange.slider("option", "max", 20);
              map.setZoom(Math.min(map._zoom, 20));
              map.options.maxZoom = 20;
              return
          } else if (maxZoom22.includes(layerType)) {
            mapZoomRange.slider("option", "max", 22);
            map.options.maxZoom = 22;
            return
          } else if (maxZoom18.includes(layerType)) {
              mapZoomRange.slider("option", "max", 18);
              map.setZoom(Math.min(map._zoom, 18));
              map.options.maxZoom = 18;
          }
          mapZoomRange.slider("value", map._zoom);
      }
    },
};
